/* Type theme */
/** ******************* */
var UitkDateNumberThemeMap = [
    ['default', 'uitk-date-number-default'],
    ['emphasis', 'uitk-date-number-emphasis'],
    ['muted', 'uitk-date-number-muted'],
    ['action', 'uitk-date-number-action'],
    ['today', 'uitk-date-number-today']
];
var UitkDateNumberThemes = new Map(UitkDateNumberThemeMap);
/* Type size */
/** ******************* */
var UitkTypeSizeMap = [
    [300, 'uitk-type-300'],
    [400, 'uitk-type-400']
];
var UitkTypeSizes = new Map(UitkTypeSizeMap);
/* Type weight */
/** ******************* */
var UitkTypeWeightMap = [
    ['regular', 'uitk-type-regular'],
    ['bold', 'uitk-type-bold']
];
var UitkTypeWeights = new Map(UitkTypeWeightMap);
/* Availability Background availability */
/** ******************* */
var UitkAvailabilityBackgroundAvailabilityMap = [
    ['available', 'uitk-background-available'],
    ['am-unavailable', 'uitk-background-am-unavailable'],
    ['pm-unavailable', 'uitk-background-pm-unavailable'],
    ['unavailable', 'uitk-background-unavailable']
];
var UitkAvailabilityBackgroundAvailabilities = new Map(UitkAvailabilityBackgroundAvailabilityMap);

export { UitkAvailabilityBackgroundAvailabilities, UitkDateNumberThemes, UitkTypeSizes, UitkTypeWeights };
